/*
 * HE5000 Series Configuration Form
 * Shopify Integration: Cart API + Slack + Editable Admin + Multi-Step Wizard
 */
(function() {
  'use strict';

  var CONFIG = {
    slackWebhookUrl: '',
    redirectAfterAdd: '/checkout',
  };

  // ---------- Schema version — bump this whenever you change a `defaultVariants`
  // group or a `he_img_*` default and want EVERY returning visitor's cached copy
  // in localStorage to be discarded so they pick up the new code defaults on load.
  // Add an entry to MIGRATIONS whenever you bump this — list the localStorage keys
  // (or key prefixes) that need to be wiped for that specific version change.
  var SCHEMA_VERSION = '2026-08-28-interior-black-hires';
  var MIGRATIONS = {
    // 2026-08-28: Replaced Beige (int-beige) with Black (int-black) in interior list
    // + swapped/updated all interior color images. Wipe cached interior variants +
    // interior image overrides so returning visitors see the new lineup.
    '2026-08-28-interior-black': [
      'he_variants_interior',
      'he_img_int-beige',
      'he_img_int-warmbeige',
      'he_img_int-stonegrey',
      'he_img_int-slategrey',
      'he_img_interior-1775665451377'
    ],
    // 2026-08-28 (hires): re-clear the interior image overrides so the width=1200
    // hi-res URLs in the code defaults kick in for returning visitors.
    '2026-08-28-interior-black-hires': [
      'he_img_int-black',
      'he_img_int-warmbeige',
      'he_img_int-stonegrey',
      'he_img_int-slategrey'
    ]
  };
  (function runSchemaMigration(){
    try {
      var stored = localStorage.getItem('he_schema_version');
      if (stored === SCHEMA_VERSION) return; // already up to date
      // Wipe every key listed for the CURRENT version (safe on first-ever visit — no-ops).
      var keys = MIGRATIONS[SCHEMA_VERSION] || [];
      keys.forEach(function(k){ try { localStorage.removeItem(k); } catch(e){} });
      localStorage.setItem('he_schema_version', SCHEMA_VERSION);
      console.log('[HE5000] Schema migrated → ' + SCHEMA_VERSION + ' (' + keys.length + ' cached key(s) cleared)');
    } catch(e) {}
  })();

  var defaultVariants = {
    wood: [{id:'wood-1',label:'Oakwood #1'},{id:'wood-2',label:'Oakwood #2'},{id:'wood-3',label:'Mahogany #3'},{id:'wood-4',label:'Mahogany #4'},{id:'wood-5',label:'Wenge #5'},{id:'wood-6',label:'Walnut #6'},{id:'wood-7',label:'Marble Pattern'},{id:'wood-8',label:'Black'}],
    carpet: [{id:'carpet-beige',label:'Beige Carpet'},{id:'carpet-light',label:'Light Carpet'},{id:'carpet-dark',label:'Dark Carpet'}],
    interior: [{id:'int-black',label:'Black'},{id:'int-warmbeige',label:'Warm Beige'},{id:'int-stonegrey',label:'Stone Grey'},{id:'int-slategrey',label:'Slate Grey'}],
    extStd_he5000: [{id:'exts-he-wh',label:'White'},{id:'exts-he-gw',label:'Glossy White'},{id:'exts-he-mb',label:'Matte Black'},{id:'exts-he-gb',label:'Glossy Black'},{id:'exts-he-gr',label:'Gray'},{id:'exts-he-or',label:'Orange'},{id:'exts-he-yl',label:'Yellow'},{id:'exts-he-rd',label:'Red'},{id:'exts-he-custom',label:'Custom Color'}],
    extStd_he5000plus: [{id:'exts-hp-wh',label:'White'},{id:'exts-hp-gw',label:'Glossy White'},{id:'exts-hp-mb',label:'Matte Black'},{id:'exts-hp-gb',label:'Glossy Black'},{id:'exts-hp-gr',label:'Gray'},{id:'exts-hp-or',label:'Orange'},{id:'exts-hp-yl',label:'Yellow'},{id:'exts-hp-rd',label:'Red'},{id:'exts-hp-custom',label:'Custom Color'}],
    extStd_he5000mini: [{id:'exts-hm-wh',label:'White'},{id:'exts-hm-gw',label:'Glossy White'},{id:'exts-hm-mb',label:'Matte Black'},{id:'exts-hm-gb',label:'Glossy Black'},{id:'exts-hm-gr',label:'Gray'},{id:'exts-hm-or',label:'Orange'},{id:'exts-hm-yl',label:'Yellow'},{id:'exts-hm-rd',label:'Red'},{id:'exts-hm-custom',label:'Custom Color'}],
    extStd_he5000fort: [{id:'exts-hf-wh',label:'White'},{id:'exts-hf-gw',label:'Glossy White'},{id:'exts-hf-mb',label:'Matte Black'},{id:'exts-hf-gb',label:'Glossy Black'},{id:'exts-hf-gr',label:'Gray'},{id:'exts-hf-or',label:'Orange'},{id:'exts-hf-yl',label:'Yellow'},{id:'exts-hf-rd',label:'Red'},{id:'exts-hf-custom-std',label:'Custom Color'}],
    extPrem_he5000: [{id:'extp-he-gg',label:'Gray Green'},{id:'extp-he-dp',label:'Dark Purple'},{id:'extp-he-nb',label:'Navy Blue'},{id:'extp-he-lb',label:'Light Blue'},{id:'extp-he-bg',label:'Beige'},{id:'extp-he-custom',label:'Custom Color'}],
    extPrem_he5000plus: [{id:'extp-hp-gg',label:'Gray Green'},{id:'extp-hp-dp',label:'Dark Purple'},{id:'extp-hp-nb',label:'Navy Blue'},{id:'extp-hp-lb',label:'Light Blue'},{id:'extp-hp-bg',label:'Beige'},{id:'extp-hp-custom',label:'Custom Color'}],
    extPrem_he5000mini: [{id:'extp-hm-gg',label:'Gray Green'},{id:'extp-hm-dp',label:'Dark Purple'},{id:'extp-hm-nb',label:'Navy Blue'},{id:'extp-hm-lb',label:'Light Blue'},{id:'extp-hm-bg',label:'Beige'},{id:'extp-hm-custom',label:'Custom Color'}],
    extPrem_he5000fort: [{id:'extp-hf-gg',label:'Gray Green'},{id:'extp-hf-dp',label:'Dark Purple'},{id:'extp-hf-nb',label:'Navy Blue'},{id:'extp-hf-lb',label:'Light Blue'},{id:'extp-hf-bg',label:'Beige'},{id:'extp-hf-custom',label:'Custom Color'}],
    regSeat: [{id:'regs-beige',label:'Beige'},{id:'regs-brown',label:'Brown'},{id:'regs-blackbrown',label:'Black & Brown'},{id:'regs-black',label:'Black'}],
    airManual: [{id:'airm-lightgrey',label:'Light Grey'},{id:'airm-beige',label:'Beige'},{id:'airm-black',label:'Black'},{id:'airm-chestnut',label:'Chestnut Brown'},{id:'airm-ivoryblue',label:'Ivory / Blue'},{id:'airm-blackwhite',label:'Black / White'},{id:'airm-silverblack',label:'Grey/Black'}],
    airManualElectric: [{id:'airme-lightgrey',label:'Light Grey'},{id:'airme-beige',label:'Beige'},{id:'airme-black',label:'Black'},{id:'airme-chestnut',label:'Chestnut Brown'},{id:'airme-ivoryblue',label:'Ivory / Blue'},{id:'airme-blackwhite',label:'Black / White'},{id:'airme-greyblack',label:'Grey/Black'}],
    premium: [{id:'prem-blackwhite-tray',label:'Black/White w/ Tray'},{id:'prem-ivory-tray',label:'Ivory/Blue w/ Tray'},{id:'prem-blackwhite-notray',label:'Black/White w/o Tray'},{id:'prem-ivory-notray',label:'Ivory/Blue w/o Tray'}],
    lighting: [{id:'light-bibs',label:'BIBS System'},{id:'light-tv',label:'TV'},{id:'light-star',label:'Star Ceiling'},{id:'light-reading',label:'Reading Light'},{id:'light-ambient',label:'Ambient Strips'},{id:'light-warranty',label:'Extended Warranty'},{id:'light-whiteglove',label:'White Glove Delivery'},{id:'light-asme',label:'ASME Certification'},{id:'light-book',label:'Protocol Book'}],
    redLight: [{id:'redlight-panel',label:'Red Light Panel'}]
  };

  var uploadSvg = '<svg viewBox="0 0 24 24"><path d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"/></svg>';
  var addSvg = '<svg viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>';

  var editMode = false;
  var selectedSeatCount = 0;
  var currentImgKey = null;

  var root = document.getElementById('he5000ConfigForm');
  if (!root) return;
  var imgInput = root.querySelector('#heImgUpload');

  function escHtml(s) { return s.replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;'); }

  // ===== VARIANTS =====
  function loadVariants(g) { try { var s=localStorage.getItem('he_variants_'+g); if(s) return JSON.parse(s); } catch(e){} return defaultVariants[g]?defaultVariants[g].slice():[]; }
  function saveVariants(g,v) { try { localStorage.setItem('he_variants_'+g, JSON.stringify(v)); } catch(e){} }

  // ===== RENDER GRIDS =====
  function renderGrid(group) {
    var grid = root.querySelector('#'+group+'Grid');
    if (!grid) return;
    var variants = loadVariants(group);
    var sel = grid.querySelector('.he-option-card.selected');
    var selId = sel ? sel.getAttribute('data-id') : null;
    grid.innerHTML = '';
    variants.forEach(function(v, idx) {
      var card = document.createElement('div');
      card.className = 'he-option-card' + (v.id === selId ? ' selected' : '');
      card.setAttribute('data-id', v.id);
      card.onclick = function(e) {
        if (!e.target.closest('.he-del-btn') && !e.target.closest('.he-upload-ov') && !e.target.closest('.he-label-input'))
          selectCard(this, group);
      };
      card.innerHTML =
        '<button class="he-del-btn" onclick="event.stopPropagation(); window.heDeleteCard(\''+group+'\','+idx+')">&times;</button>' +
        '<div class="he-card-img" data-img-key="'+v.id+'"><div class="he-placeholder">&#128247;<span>Upload</span></div>' +
        '<div class="he-upload-ov" onclick="event.stopPropagation(); window.heTriggerUpload(\''+v.id+'\')">'+uploadSvg+' Upload</div></div>' +
        '<div class="he-card-label"><input class="he-label-input" type="text" value="'+escHtml(v.label)+'" onchange="window.heRenameCard(\''+group+'\','+idx+',this.value)" onclick="event.stopPropagation()" /></div>' +
        '<div class="he-check">&#10003;</div>';
      grid.appendChild(card);
      try { var si=localStorage.getItem('he_img_'+v.id); if(si) setImage(v.id, si); } catch(e){}
    });
    var addBtn = document.createElement('div');
    addBtn.className = 'he-add-btn';
    addBtn.onclick = function() { addCard(group); };
    addBtn.innerHTML = addSvg + '<span>Add Variant</span>';
    grid.appendChild(addBtn);
  }

  // ===== CARD ACTIONS =====
  function selectCard(el, group) {
    if (root.classList.contains('edit-mode')) return;
    var grid = el.closest('.he-card-grid');
    if (grid.classList.contains('he-preview-only')) return;
    grid.querySelectorAll('.he-option-card').forEach(function(c){c.classList.remove('selected');});
    el.classList.add('selected');
    toggleRalCode();
    updateSummary();
    updateSelectionSummaries();
  }
  function addCard(group) {
    var v=loadVariants(group); v.push({id:group+'-'+Date.now(),label:'New Variant'}); saveVariants(group,v); renderGrid(group);
  }
  window.heDeleteCard = function(group, idx) {
    var v=loadVariants(group); if(v.length<=1){alert('Keep at least one variant.');return;} var rem=v.splice(idx,1)[0]; saveVariants(group,v);
    try{localStorage.removeItem('he_img_'+rem.id);}catch(e){} renderGrid(group); updateSummary();
  };
  window.heRenameCard = function(group, idx, val) {
    var v=loadVariants(group); if(v[idx]){v[idx].label=val.trim()||'Untitled'; saveVariants(group,v);}
  };

  // ===== IMAGE UPLOAD (URL only) =====
  window.heTriggerUpload = function(key) {
    if (!root.classList.contains('edit-mode')) return;
    var currentUrl = '';
    try { currentUrl = localStorage.getItem('he_img_' + key) || ''; } catch(e) {}
    if (currentUrl && currentUrl.indexOf('data:') === 0) currentUrl = '';
    var url = prompt('Paste image URL (Shopify CDN):\n\nUpload images to Shopify Admin → Content → Files,\nthen copy the URL and paste here.\n\nLeave blank to remove image.', currentUrl);
    if (url === null) return;
    if (url.trim() === '') {
      var wrap = root.querySelector('[data-img-key="' + key + '"]');
      if (wrap) {
        var img = wrap.querySelector('img');
        var ph = wrap.querySelector('.he-placeholder');
        if (img) img.remove();
        if (ph) ph.style.display = '';
      }
      try { localStorage.removeItem('he_img_' + key); } catch(e) {}
      return;
    }
    setImage(key, url.trim());
    try { localStorage.setItem('he_img_' + key, url.trim()); } catch(e) {}
  };
  imgInput.addEventListener('change', function(e) {
    var file = e.target.files[0];
    if (!file || !currentImgKey) return;
    // Compress image before storing
    var img = new Image();
    var reader = new FileReader();
    reader.onload = function(ev) {
      img.onload = function() {
        var canvas = document.createElement('canvas');
        var maxW = 400, maxH = 400;
        var w = img.width, h = img.height;
        if (w > maxW || h > maxH) {
          var ratio = Math.min(maxW / w, maxH / h);
          w = Math.round(w * ratio);
          h = Math.round(h * ratio);
        }
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        var compressed = canvas.toDataURL('image/jpeg', 0.7);
        setImage(currentImgKey, compressed);
        try { localStorage.setItem('he_img_' + currentImgKey, compressed); } catch(e) {
          alert('Image still too large for localStorage. Please use option 2 (Shopify CDN URL) instead.');
        }
        currentImgKey = null;
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
    imgInput.value = '';
  });
  function setImage(key, dataUrl) {
    var wrap=root.querySelector('[data-img-key="'+key+'"]'); if(!wrap) return;
    var img=wrap.querySelector('img'); var ph=wrap.querySelector('.he-placeholder');
    if(!img){img=document.createElement('img'); wrap.insertBefore(img, wrap.firstChild);}
    img.src=dataUrl; if(ph) ph.style.display='none';
  }

  // ===== EDIT MODE =====
  var stepOrder = ['sec-base','sec-floor','sec-interior','sec-exterior','sec-seating','sec-redlight','sec-lighting'];

  window.heToggleEdit = function() {
    editMode = !editMode;
    root.classList.toggle('edit-mode', editMode);
    root.querySelector('#heEditToggle').classList.toggle('active', editMode);
    root.querySelectorAll('[data-edit-key]').forEach(function(el){el.contentEditable=editMode?'true':'false';});
    if (editMode) {
      stepOrder.forEach(function(id){var s=root.querySelector('#'+id); s.classList.remove('locked','done'); s.classList.add('active');});
    } else { initWizard(); }
  };

  // ===== EDITABLE TEXT =====
  document.addEventListener('blur', function(e) {
    var el=e.target.closest?e.target.closest('[data-edit-key]'):null;
    if(el){try{localStorage.setItem('he_text_'+el.getAttribute('data-edit-key'), el.innerHTML);}catch(e){}}
  }, true);
  function loadSavedTexts() {
    root.querySelectorAll('[data-edit-key]').forEach(function(el){
      try{var s=localStorage.getItem('he_text_'+el.getAttribute('data-edit-key')); if(s!==null) el.innerHTML=s;}catch(e){}
    });
  }

  // ===== EDITABLE PRICES =====
  window.heSavePriceEdit = function(input) {
    var key=input.getAttribute('data-price-key'); var val=parseInt(input.value)||0;
    try{localStorage.setItem('he_price_'+key, val);}catch(e){}
    root.querySelectorAll('[data-price-display="'+key+'"]').forEach(function(span){span.textContent=val.toLocaleString();});
    var sib=input.parentElement.querySelector('.he-price-display');
    if(sib) sib.textContent=val>0?'+$'+val.toLocaleString():'Included';
  };
  window.heSyncLightingPrice = function(input) {
    var label=input.closest('label'); if(label){var cb=label.querySelector('input[type="checkbox"]'); if(cb) cb.setAttribute('data-price',parseInt(input.value)||0);}
  };
  function loadSavedPrices() {
    // One-time price migrations: bump version when overriding a cached price default.
    try {
      var PRICE_MIGRATIONS_VERSION = '2026-04-24-star1500-asme0';
      if (localStorage.getItem('he_price_migrations') !== PRICE_MIGRATIONS_VERSION) {
        localStorage.setItem('he_price_light-star', '1500');
        localStorage.setItem('he_price_light-asme', '0');
        localStorage.setItem('he_price_migrations', PRICE_MIGRATIONS_VERSION);
      }
    } catch(e){}
    root.querySelectorAll('.he-price-edit').forEach(function(input){
      var key=input.getAttribute('data-price-key');
      try{var s=localStorage.getItem('he_price_'+key); if(s!==null){input.value=parseInt(s);
        root.querySelectorAll('[data-price-display="'+key+'"]').forEach(function(span){span.textContent=parseInt(s).toLocaleString();});
        window.heSyncLightingPrice(input);
      }}catch(e){}
    });
  }
  function getPrice(key, fallback) { try{var s=localStorage.getItem('he_price_'+key); if(s!==null) return parseInt(s);}catch(e){} return fallback; }

  // ===== ADD/REMOVE OPTIONS =====
  window.heAddOption = function(groupId, inputName, inputType) {
    if(!editMode) return; var name=prompt('Enter option name:'); if(!name||!name.trim()) return;
    var group=root.querySelector('#'+groupId); var label=document.createElement('label');
    label.innerHTML='<input type="'+inputType+'" name="'+inputName+'" value="'+escHtml(name.trim())+'" onchange="heUpdateSummary()"><span>'+escHtml(name.trim())+'</span><button class="he-opt-del" onclick="event.preventDefault(); window.heRemoveOption(\''+groupId+'\',this)">&times;</button>';
    group.appendChild(label); heSaveOptionGroup(groupId, inputName, inputType);
  };
  window.heRemoveOption = function(groupId, btn) {
    if(!editMode) return; var group=root.querySelector('#'+groupId);
    if(group.querySelectorAll('label').length<=1){alert('Keep at least one option.');return;}
    btn.closest('label').remove(); var inp=group.querySelector('input'); if(inp) heSaveOptionGroup(groupId,inp.name,inp.type); updateSummary();
  };
  function heSaveOptionGroup(groupId, inputName, inputType) {
    var group=root.querySelector('#'+groupId); var opts=[];
    group.querySelectorAll('label').forEach(function(l){var s=l.querySelector('span'),i=l.querySelector('input'); if(s&&i) opts.push({label:s.textContent,value:i.value});});
    try{localStorage.setItem('he_opts_'+groupId, JSON.stringify({name:inputName,type:inputType,options:opts}));}catch(e){}
  }
  function loadSavedOptions() {
    root.querySelectorAll('[data-option-group]').forEach(function(group){
      var gid=group.id; try{var s=localStorage.getItem('he_opts_'+gid); if(!s) return; var d=JSON.parse(s); group.innerHTML='';
      d.options.forEach(function(opt){var label=document.createElement('label');
        label.innerHTML='<input type="'+d.type+'" name="'+d.name+'" value="'+escHtml(opt.value)+'" onchange="heUpdateSummary()"><span>'+escHtml(opt.label)+'</span><button class="he-opt-del" onclick="event.preventDefault(); window.heRemoveOption(\''+gid+'\',this)">&times;</button>';
        group.appendChild(label);});}catch(e){}
    });
  }
  window.heAddLightingOption = function() {
    if(!editMode) return; var name=prompt('Enter lighting option name:'); if(!name||!name.trim()) return;
    var price=prompt('Enter price (0 for included):','0'); var pv=parseInt(price)||0;
    var group=root.querySelector('#lightingGroup'); var pk='light-custom-'+Date.now(); var label=document.createElement('label');
    label.innerHTML='<input type="checkbox" name="lighting" value="'+escHtml(name.trim())+'" data-price="'+pv+'" onchange="heUpdateSummary()"><span>'+escHtml(name.trim())+'</span><span class="he-price-tag">+$<span class="he-price-display">'+(pv>0?pv.toLocaleString():'Included')+'</span><input class="he-price-edit" data-price-key="'+pk+'" type="number" value="'+pv+'" onchange="heSavePriceEdit(this); heSyncLightingPrice(this); heUpdateSummary()"></span><button class="he-opt-del" onclick="event.preventDefault(); window.heRemoveOption(\'lightingGroup\',this)">&times;</button>';
    group.appendChild(label); try{localStorage.setItem('he_price_'+pk, pv);}catch(e){}
  };

  // ===== LIGHTING SUB-OPTIONS =====
  window.heToggleLightingSub = function() {
    var rc=root.querySelector('input[name="lighting"][value="Reading Light"]');
    var ac=root.querySelector('input[name="lighting"][value="Ambient Light Strips"]');
    root.querySelector('#readingLightSub').classList.toggle('active', !!(rc&&rc.checked));
    root.querySelector('#ambientLightSub').classList.toggle('active', !!(ac&&ac.checked));
  };

  // White Glove Delivery — show dropdown when checked, update price based on tier
  window.heToggleWhiteGlove = function() {
    var wg = root.querySelector('input[name="lighting"][value="White Glove Delivery"]');
    var sub = root.querySelector('#whiteGloveSub');
    if (sub) sub.classList.toggle('active', !!(wg && wg.checked));
    heWhiteGloveTierChange();
  };
  window.heWhiteGloveTierChange = function() {
    var wg = root.querySelector('input[name="lighting"][value="White Glove Delivery"]');
    var tier = root.querySelector('#whiteGloveTier');
    var priceDisp = root.querySelector('#whiteGlovePrice');
    if (!wg || !tier) return;
    var price = tier.value === 'Premium' ? 6000 : 4000;
    wg.setAttribute('data-price', price);
    if (priceDisp) priceDisp.textContent = price.toLocaleString();
  };

  // BIBS Oxygen System Upgrade — single tier dropdown, price comes from the selected option
  window.heToggleBibsSub = function() {
    var cb = root.querySelector('input[name="lighting"][value="BIBS Oxygen System Upgrade"]');
    var sub = root.querySelector('#bibsSystemSub');
    if (sub) sub.classList.toggle('active', !!(cb && cb.checked));
    window.heBibsChange();
  };
  window.heBibsChange = function() {
    var cb = root.querySelector('input[name="lighting"][value="BIBS Oxygen System Upgrade"]');
    var tier = root.querySelector('#bibsTier');
    if (!cb) return;
    var priceDisp = cb.closest('label').querySelector('.he-price-display');
    if (!cb.checked) {
      cb.setAttribute('data-price', 0);
      if (priceDisp) priceDisp.textContent = 'Select options';
      return;
    }
    if (!tier) return;
    var price = parseInt(tier.selectedOptions[0].getAttribute('data-price')) || 0;
    cb.setAttribute('data-price', price);
    if (priceDisp) priceDisp.textContent = '+$' + price.toLocaleString();
  };

  // ===== MODEL-SPECIFIC EXTERIOR =====
  var modelKeyMap = {'HE5000':'he5000','HE5000 Plus':'he5000plus','HE5000 Mini':'he5000mini','HE5000 Fort':'he5000fort'};

  window.heToggleExteriorByModel = function() {
    var bm=root.querySelector('input[name="baseModel"]:checked'); var mv=bm?bm.value:'';
    root.querySelectorAll('[data-ext-model]').forEach(function(div){div.style.display=(div.getAttribute('data-ext-model')===mv)?'block':'none';});
    toggleRalCode();
    window.heToggleOptionsByModel();
  };

  // Hide any element marked `data-hide-for-model="<Model>"` when that model is selected.
  // Also unchecks any hidden checkbox so a stale selection doesn't bleed into cart.
  window.heToggleOptionsByModel = function() {
    var bm = root.querySelector('input[name="baseModel"]:checked');
    var mv = bm ? bm.value : '';
    root.querySelectorAll('[data-hide-for-model]').forEach(function(el) {
      var hideFor = el.getAttribute('data-hide-for-model');
      // Supports a single model or comma-separated list ("HE5000 Fort,HE5000 Mini")
      var hidden = hideFor.split(',').map(function(s){return s.trim();}).indexOf(mv) !== -1;
      el.style.display = hidden ? 'none' : '';
      if (hidden) {
        var cb = el.querySelector('input[type="checkbox"]');
        if (cb && cb.checked) { cb.checked = false; }
      }
    });
  };

  // ===== RAL CODE TOGGLE =====
  function toggleRalCode() {
    var ralSection = root.querySelector('#ralCodeSection');
    if (!ralSection) return;
    var showRal = false;
    var extGroups = ['extStd_he5000','extStd_he5000plus','extStd_he5000mini','extStd_he5000fort',
                     'extPrem_he5000','extPrem_he5000plus','extPrem_he5000mini','extPrem_he5000fort'];
    extGroups.forEach(function(g) {
      var grid = root.querySelector('#' + g + 'Grid');
      if (!grid) return;
      var parent = grid.closest('.he-cond');
      if (parent && !parent.classList.contains('active')) return;
      var parentModel = grid.closest('[data-ext-model]');
      if (parentModel && parentModel.style.display === 'none') return;
      var sel = grid.querySelector('.he-option-card.selected');
      if (sel) {
        var label = sel.querySelector('.he-label-input');
        if (label && label.value.toLowerCase().indexOf('custom') > -1) showRal = true;
      }
    });
    ralSection.classList.toggle('active', showRal);
    if (!showRal) {
      var ralInput = root.querySelector('#ralNoteInput');
      if (ralInput) ralInput.value = '';
    }
  }
  function getActiveExtGrid(type) {
    var bm=root.querySelector('input[name="baseModel"]:checked'); if(!bm) return null;
    var key=modelKeyMap[bm.value]; if(!key) return null;
    return type==='std'?'extStd_'+key+'Grid':'extPrem_'+key+'Grid';
  }

  // ===== TOGGLES =====
  window.heToggleFlooring = function() {
    var v=root.querySelector('input[name="flooringType"]:checked'); v=v?v.value:'';
    root.querySelector('#woodSection').classList.toggle('active',v==='Vinyl');
    root.querySelector('#carpetSection').classList.toggle('active',v==='Carpet');
    updateSummary();
  };
  window.heToggleExterior = function() {
    var v=root.querySelector('input[name="exteriorType"]:checked'); v=v?v.value:'';
    root.querySelector('#stdExteriorSection').classList.toggle('active',v==='Standard');
    root.querySelector('#premExteriorSection').classList.toggle('active',v==='Premium');
    toggleRalCode();
    updateSummary();
  };
  window.heToggleSeating = function() {
    var v=root.querySelector('input[name="seatType"]:checked'); v=v?v.value:'';
    root.querySelector('#regularSeatSection').classList.toggle('active',v==='Regular');
    root.querySelector('#airlineSeatSection').classList.toggle('active',v==='Airline');
    if(v==='Airline') window.heToggleAirline();
    updateSummary();
  };
  window.heToggleAirline = function() {
    var v=root.querySelector('input[name="airlineOption"]:checked'); v=v?v.value:'';
    root.querySelector('#manualAirlineSection').classList.toggle('active',v==='Manual');
    var me = root.querySelector('#manualElectricSection'); if (me) me.classList.toggle('active',v==='ManualElectric');
    var ps = root.querySelector('#premiumSection'); if (ps) ps.classList.toggle('active',v==='Premium');
    updateSummary();
  };
  window.heSelectSeatCount = function(el, val) {
    root.querySelectorAll('.he-num-btn').forEach(function(b){b.classList.remove('selected');});
    el.classList.add('selected');
    selectedSeatCount=val;
    var customSec = root.querySelector('#customSeatSection');
    if (customSec) customSec.classList.toggle('active', val === 'Custom');
    if (val !== 'Custom') { var note = root.querySelector('#customSeatNote'); if (note) note.value = ''; }
    updateSummary();
  };
  window.heUpdateSummary = function() { updateSummary(); };

  // ===== MULTI-STEP WIZARD =====
  function initWizard() {
    stepOrder.forEach(function(id,i){var sec=root.querySelector('#'+id); sec.classList.remove('active','done','locked');
      if(i===0) sec.classList.add('active'); else sec.classList.add('locked');});
  }
  window.heToggleSection = function(secId) {
    if(editMode){var sec=root.querySelector('#'+secId); if(sec.classList.contains('active')){sec.classList.remove('active');}
      else{stepOrder.forEach(function(id){root.querySelector('#'+id).classList.remove('active');}); sec.classList.add('active');} return;}
    var sec=root.querySelector('#'+secId); if(sec.classList.contains('locked')) return;
    if(sec.classList.contains('active')){sec.classList.remove('active');}
    else if(sec.classList.contains('done')){stepOrder.forEach(function(id){root.querySelector('#'+id).classList.remove('active');}); sec.classList.remove('done'); sec.classList.add('active');}
  };
  // Validate current step before advancing
  function validateStep(secId) {
    if (secId === 'sec-base') {
      if (!root.querySelector('input[name="baseModel"]:checked')) return 'Please select a base model.';
    }
    if (secId === 'sec-floor') {
      var ft = root.querySelector('input[name="flooringType"]:checked');
      if (!ft) return 'Please select a flooring type (Vinyl or Carpet).';
      if (ft.value === 'Vinyl' && !getSelectedLabel('woodGrid')) return 'Please select a vinyl flooring option.';
      if (ft.value === 'Carpet' && !getSelectedLabel('carpetGrid')) return 'Please select a carpet flooring option.';
    }
    if (secId === 'sec-interior') {
      if (!getSelectedLabel('interiorGrid')) return 'Please select an interior color.';
    }
    if (secId === 'sec-exterior') {
      var et = root.querySelector('input[name="exteriorType"]:checked');
      if (!et) return 'Please select Standard or Premium exterior.';
      var extGrid = getActiveExtGrid(et.value === 'Standard' ? 'std' : 'prem');
      if (extGrid && !getSelectedLabel(extGrid)) return 'Please select an exterior color.';
      // If Custom Color was picked, RAL code is required
      var sel = extGrid ? root.querySelector('#' + extGrid + ' .he-option-card.selected') : null;
      if (sel) {
        var lbl = sel.querySelector('.he-label-input');
        if (lbl && lbl.value.toLowerCase().indexOf('custom') > -1) {
          var ral = root.querySelector('#ralNoteInput');
          if (!ral || !ral.value.trim()) return 'Please enter a RAL code for your custom color.';
        }
      }
    }
    if (secId === 'sec-seating') {
      var st = root.querySelector('input[name="seatType"]:checked');
      if (!st) return 'Please select a seat type.';
      if (st.value === 'Regular' && !getSelectedLabel('regSeatGrid')) return 'Please select a regular seat color.';
      if (st.value === 'Airline') {
        var ao = root.querySelector('input[name="airlineOption"]:checked');
        if (!ao) return 'Please select an airline seat option.';
        if (ao.value === 'Manual' && !getSelectedLabel('airManualGrid')) return 'Please select a manual airline seat color.';
        if (ao.value === 'ManualElectric' && !getSelectedLabel('airManualElectricGrid')) return 'Please select a Manual Electric seat color.';
        if (ao.value === 'Premium' && !getSelectedLabel('premiumGrid')) return 'Please select a Premium First Class seat option.';
      }
      if (!selectedSeatCount) return 'Please select the number of seats.';
      if (selectedSeatCount === 'Custom') {
        var note = root.querySelector('#customSeatNote');
        if (!note || !note.value.trim()) return 'Please describe your custom seating needs (or call us at the number shown).';
      }
    }
    if (secId === 'sec-redlight') {
      if (!root.querySelector('input[name="redLightPanel"]:checked')) return 'Please select Yes or No for Red Light Therapy.';
    }
    if (secId === 'sec-lighting') {
      var lc = root.querySelectorAll('input[name="lighting"]:checked');
      if (!lc.length) return 'Please select at least one option from Additional Options.';
      // If Reading Light is selected, sub-option must be chosen
      var readCb = root.querySelector('input[name="lighting"][value="Reading Light"]');
      if (readCb && readCb.checked) {
        if (!root.querySelector('input[name="readingLightColor"]:checked')) return 'Please choose Warm White or Cold White for the Reading Light.';
      }
    }
    return null;
  }

  var stepLabels = {
    'sec-base': 'Base Model',
    'sec-floor': 'Flooring',
    'sec-interior': 'Interior Color',
    'sec-exterior': 'Exterior Color',
    'sec-seating': 'Seating',
    'sec-redlight': 'Red Light Therapy',
    'sec-lighting': 'Additional Options'
  };

  window.heAdvanceToNext = function(currentSecId) {
    if(editMode) return;
    var err = validateStep(currentSecId);
    if (err) { alert(err); return; }
    var currentIdx = stepOrder.indexOf(currentSecId);
    var sec=root.querySelector('#'+currentSecId);
    sec.classList.remove('active','locked'); sec.classList.add('done'); updateSelectionSummaries();
    // Look FORWARD only — next undone step after current
    var nextSec = null;
    for (var j = currentIdx + 1; j < stepOrder.length; j++) {
      var s = root.querySelector('#' + stepOrder[j]);
      if (s && !s.classList.contains('done')) { nextSec = s; break; }
    }
    if (nextSec) {
      nextSec.classList.remove('locked'); nextSec.classList.add('active');
      setTimeout(function(){ nextSec.scrollIntoView({behavior:'smooth',block:'start'}); },100);
    } else {
      var summary = root.querySelector('.he-summary');
      if (summary) setTimeout(function(){ summary.scrollIntoView({behavior:'smooth',block:'start'}); },100);
    }
  };
  window.heOnSelect = function(secId) { setTimeout(function(){window.heAdvanceToNext(secId);},350); };

  // ===== HELPERS =====
  function getSelectedLabel(gridId) {
    var grid=root.querySelector('#'+gridId); if(!grid) return null;
    var sel=grid.querySelector('.he-option-card.selected'); if(!sel) return null;
    var inp=sel.querySelector('.he-label-input'); return inp?inp.value:null;
  }
  function getSelectedThumb(gridId) {
    var grid=root.querySelector('#'+gridId); if(!grid) return '';
    var sel=grid.querySelector('.he-option-card.selected'); if(!sel) return '';
    var img=sel.querySelector('.he-card-img img');
    if(img) return '<img class="he-sel-thumb" src="'+img.src+'">';
    return '<div class="he-sel-thumb" style="display:flex;align-items:center;justify-content:center;color:#27ae60;font-size:1.5em;">&#10003;</div>';
  }
  function buildSelHtml(thumb, label, sub, secId) {
    return thumb+'<div class="he-sel-text"><span class="he-sel-label">'+label+'</span>'+(sub?'<span class="he-sel-sub">'+sub+'</span>':'')+'</div>'+
      '<span class="he-sel-change" onclick="event.stopPropagation(); heToggleSection(\''+secId+'\')">Change</span>';
  }

  // Helper: get image from static element by img key
  function getStaticThumb(imgKey) {
    var wrap=root.querySelector('[data-img-key="'+imgKey+'"]');
    if(!wrap) return '';
    var img=wrap.querySelector('img');
    if(img) return '<img class="he-sel-thumb" src="'+img.src+'">';
    return '';
  }
  // Helper: get image from grid by matching card label
  function getGridThumbByLabel(gridId, label) {
    var grid=root.querySelector('#'+gridId); if(!grid) return '';
    var cards=grid.querySelectorAll('.he-option-card');
    for(var i=0;i<cards.length;i++){
      var lbl=cards[i].querySelector('.he-label-input');
      if(lbl&&lbl.value===label){
        var img=cards[i].querySelector('.he-card-img img');
        if(img) return '<img class="he-sel-thumb" src="'+img.src+'">';
        return '';
      }
    }
    return '';
  }

  // ===== SELECTION SUMMARIES =====
  function updateSelectionSummaries() {
    var chk='<span style="color:#27ae60;font-size:1.2em;">&#10003;</span> ';
    // Base
    var bm=root.querySelector('input[name="baseModel"]:checked'); var selBase=root.querySelector('#sel-base');
    if(selBase&&bm){
      var baseCard=root.querySelector('.he-base-model-card.selected .he-card-img img');
      var baseThumb=baseCard?'<img class="he-sel-thumb" src="'+baseCard.src+'">':'';
      if(!baseThumb) baseThumb='<div class="he-sel-thumb" style="display:flex;align-items:center;justify-content:center;color:#27ae60;font-size:1.5em;">&#10003;</div>';
      selBase.innerHTML=buildSelHtml(baseThumb,bm.value,'Base Model','sec-base');
    } else if(selBase){selBase.innerHTML='';}
    // Flooring
    var ft=root.querySelector('input[name="flooringType"]:checked'); var selFloor=root.querySelector('#sel-floor');
    if(selFloor&&ft){var fL=ft.value,fS='',fT='';
      if(ft.value==='Vinyl'){var wl=getSelectedLabel('woodGrid'); if(wl) fL=wl; fS='Vinyl Flooring'; fT=getSelectedThumb('woodGrid');}
      if(ft.value==='Carpet'){var cl=getSelectedLabel('carpetGrid'); if(cl) fL=cl; fS='Carpet Flooring'; fT=getSelectedThumb('carpetGrid');}
      selFloor.innerHTML=buildSelHtml(fT,fL,fS,'sec-floor');} else if(selFloor){selFloor.innerHTML='';}
    // Interior
    var intL=getSelectedLabel('interiorGrid'); var selInt=root.querySelector('#sel-interior');
    if(selInt) selInt.innerHTML=intL?buildSelHtml(getSelectedThumb('interiorGrid'),intL,'Interior Color','sec-interior'):'';
    // Exterior
    var et=root.querySelector('input[name="exteriorType"]:checked'); var selExt=root.querySelector('#sel-exterior');
    if(selExt&&et){var eL='',eS='',eT='';
      if(et.value==='Standard'){var sg=getActiveExtGrid('std'); var sl=sg?getSelectedLabel(sg):null; eL=sl||'Standard'; eS='Standard Exterior'; eT=sg?getSelectedThumb(sg):'';}
      if(et.value==='Premium'){var pg=getActiveExtGrid('prem'); var pl=pg?getSelectedLabel(pg):null; eL=pl||'Premium'; eS='Premium Exterior (+$'+getPrice('premium-exterior',3500).toLocaleString()+')'; eT=pg?getSelectedThumb(pg):'';}
      selExt.innerHTML=buildSelHtml(eT,eL,eS,'sec-exterior');} else if(selExt){selExt.innerHTML='';}
    // Seating
    var st=root.querySelector('input[name="seatType"]:checked'); var selSeat=root.querySelector('#sel-seating');
    if(selSeat&&st){var sL='',sS='',sT='';
      if(st.value==='Regular'){var rl=getSelectedLabel('regSeatGrid'); sL=rl||'Regular Seat'; sS='Regular Seat'; sT=getSelectedThumb('regSeatGrid');}
      else{var ao=root.querySelector('input[name="airlineOption"]:checked');
        if(ao&&ao.value==='Manual'){var ml=getSelectedLabel('airManualGrid'); sL=ml||'Manual Airline'; sS='Manual Airline Seat'; sT=getSelectedThumb('airManualGrid');}
        else if(ao&&ao.value==='ManualElectric'){var eme=getSelectedLabel('airManualElectricGrid'); sL=eme||'Manual Style (Electric)'; sS='Manual Style Electric (+$'+getPrice('manual-electric-seat',1500).toLocaleString()+'/ea)'; sT=getSelectedThumb('airManualElectricGrid');}
        else if(ao&&ao.value==='Premium'){var ep=getSelectedLabel('premiumGrid'); sL=ep||'Premium First Class'; sS='Premium First Class (+$'+getPrice('premium-first',2500).toLocaleString()+'/ea)'; sT=getSelectedThumb('premiumGrid');}
        else{sL='Airline Seat';sS='';}}
      if(selectedSeatCount==='Custom') sS+=' &bull; Custom seats'; else if(selectedSeatCount>0) sS+=' &bull; '+selectedSeatCount+' seat(s)';
      selSeat.innerHTML=buildSelHtml(sT,sL,sS,'sec-seating');} else if(selSeat){selSeat.innerHTML='';}
    // Red Light Therapy
    var rlpEl=root.querySelector('input[name="redLightPanel"]:checked'); var selRedLight=root.querySelector('#sel-redlight');
    if(selRedLight&&rlpEl){
      var rlpLabel=rlpEl.value==='Yes'?'Red Light Panel':'Not included';
      var rlpSub=rlpEl.value==='Yes'?'Therapy Upgrade (+$'+getPrice('red-light-therapy',1000).toLocaleString()+')':'';
      var rlpThumb='';
      if(rlpEl.value==='Yes'){
        var rlGrid=root.querySelector('#redLightGrid');
        var rlImg=rlGrid?rlGrid.querySelector('.he-card-img img'):null;
        if(rlImg) rlpThumb='<img class="he-sel-thumb" src="'+rlImg.src+'">';
      }
      if(!rlpThumb) rlpThumb='<div class="he-sel-thumb" style="display:flex;align-items:center;justify-content:center;color:#27ae60;font-size:1.5em;">&#10003;</div>';
      selRedLight.innerHTML=buildSelHtml(rlpThumb,rlpLabel,rlpSub,'sec-redlight');
    } else if(selRedLight){selRedLight.innerHTML='';}
    // Lighting
    var lc=root.querySelectorAll('input[name="lighting"]:checked'); var selLight=root.querySelector('#sel-lighting');
    if(selLight&&lc.length){var ln=[]; lc.forEach(function(cb){ln.push(cb.value);});
      // Use first checked lighting item's image from the preview grid
      var lightLabelMap={'Star Ceiling Light':'Star Ceiling','Reading Light':'Reading Light','Ambient Light Strips':'Ambient Strips'};
      var firstLabel=lightLabelMap[lc[0].value]||lc[0].value;
      var lightThumb=getGridThumbByLabel('lightingGrid',firstLabel);
      if(!lightThumb) lightThumb='<div class="he-sel-thumb" style="display:flex;align-items:center;justify-content:center;color:#27ae60;font-size:1.5em;">&#10003;</div>';
      selLight.innerHTML=buildSelHtml(lightThumb,ln.join(', '),'Additional Options','sec-lighting');
    } else if(selLight){
      selLight.innerHTML=buildSelHtml('<div class="he-sel-thumb" style="display:flex;align-items:center;justify-content:center;color:#27ae60;font-size:1.5em;">&#10003;</div>','None selected','Additional Options','sec-lighting');
    }
  }

  // ===== SUMMARY =====
  function getSummaryData() {
    var total=0, rows=[];
    var bm=root.querySelector('input[name="baseModel"]:checked');
    rows.push({cat:'Base Model',sel:bm?bm.value:null,price:0});
    var ft=root.querySelector('input[name="flooringType"]:checked'); var fd=null;
    if(ft&&ft.value==='Vinyl'){var wl=getSelectedLabel('woodGrid'); fd=wl?'Vinyl - '+wl:'Vinyl';}
    else if(ft&&ft.value==='Carpet'){var cl=getSelectedLabel('carpetGrid'); fd=cl?'Carpet - '+cl:'Carpet';}
    rows.push({cat:'Flooring',sel:fd,price:0});
    rows.push({cat:'Interior Color',sel:getSelectedLabel('interiorGrid'),price:0});
    var et=root.querySelector('input[name="exteriorType"]:checked'); var ed=null,ep=0;
    if(et&&et.value==='Standard'){var sg=getActiveExtGrid('std'); var sl=sg?getSelectedLabel(sg):null; ed=sl?'Standard - '+sl:'Standard';}
    else if(et&&et.value==='Premium'){ep=getPrice('premium-exterior',3500); var pg=getActiveExtGrid('prem'); var pl=pg?getSelectedLabel(pg):null; ed=pl?'Premium - '+pl:'Premium';}
    var ralNote=root.querySelector('#ralNoteInput'); if(ralNote&&ralNote.value.trim()&&ed) ed+=' | RAL: '+ralNote.value.trim();
    total+=ep; rows.push({cat:'Exterior Color',sel:ed,price:ep});
    // Custom Logo Request
    var logoCheck=root.querySelector('#customLogoRequest');
    if(logoCheck&&logoCheck.checked){
      rows.push({cat:'Custom Logo',sel:'Yes - customer will email logo file',price:0});
    }
    var st=root.querySelector('input[name="seatType"]:checked'); var sd=null,sp=0,isCustomSeats=(selectedSeatCount==='Custom');
    if(st&&st.value==='Regular'){var rl=getSelectedLabel('regSeatGrid'); sd=rl?'Regular - '+rl:'Regular Seat';}
    else if(st&&st.value==='Airline'){var ao=root.querySelector('input[name="airlineOption"]:checked');
      if(ao&&ao.value==='Manual'){var ml=getSelectedLabel('airManualGrid'); sd=ml?'Manual Airline - '+ml:'Manual Airline';}
      else if(ao&&ao.value==='ManualElectric'){var qtyME=(typeof selectedSeatCount==='number'&&selectedSeatCount>0)?selectedSeatCount:1; if(!isCustomSeats) sp=getPrice('manual-electric-seat',1500)*qtyME; var eme=getSelectedLabel('airManualElectricGrid'); sd=eme?'Manual Style Electric - '+eme:'Manual Style Electric';}
      else if(ao&&ao.value==='Premium'){var qtyP=(typeof selectedSeatCount==='number'&&selectedSeatCount>0)?selectedSeatCount:1; if(!isCustomSeats) sp=getPrice('premium-first',2500)*qtyP; var ep=getSelectedLabel('premiumGrid'); sd=ep?'Premium First Class - '+ep:'Premium First Class';}}
    // Combine seat selection with seat count
    if(sd){
      if(isCustomSeats){
        var cn=root.querySelector('#customSeatNote'); var nv=cn&&cn.value.trim()?cn.value.trim():'';
        sd += ' - Custom'+(nv?' ('+nv+')':' (customer will call)');
      } else if(selectedSeatCount>0){
        sd += (selectedSeatCount>1?' (\u00d7'+selectedSeatCount+')':'');
      }
    }
    total+=sp;
    rows.push({cat:'Seating',sel:sd,price:sp,customSeats:isCustomSeats});
    // Red Light Therapy
    var rlp=root.querySelector('input[name="redLightPanel"]:checked'); var rlpDetail=null, rlpPrice=0;
    if(rlp){ if(rlp.value==='Yes'){ rlpPrice=getPrice('red-light-therapy',1000); rlpDetail='Red Light Panel'; } else { rlpDetail='Not included'; } }
    total+=rlpPrice; rows.push({cat:'Red Light Therapy',sel:rlpDetail,price:rlpPrice});
    var lc=root.querySelectorAll('input[name="lighting"]:checked'); var li=[],lp=0;
    lc.forEach(function(cb){
      var n=cb.value;
      if(cb.value==='Reading Light'){var rlc=root.querySelector('input[name="readingLightColor"]:checked'); if(rlc) n+=' ('+rlc.value+')';}
      if(cb.value==='Ambient Light Strips'){var acn=root.querySelector('#ambientColorNote'); if(acn&&acn.value.trim()) n+=' ('+acn.value.trim()+')';}
      if(cb.value==='White Glove Delivery'){var wgt=root.querySelector('#whiteGloveTier'); if(wgt) n+=' ('+wgt.value+')';}
      if(cb.value==='BIBS Oxygen System Upgrade'){
        var bt=root.querySelector('#bibsTier');
        if (bt) {
          var tierLabel = bt.selectedOptions[0].getAttribute('data-label') || bt.value;
          n += ' — ' + tierLabel;
        }
      }
      var p=parseInt(cb.getAttribute('data-price')||0);
      li.push(n+(p>0?' (+$'+p.toLocaleString()+')':' (Included)'));
      lp+=p;
    });
    total+=lp;
    // Break each entry onto its own line for readability
    var lightingSel = li.length ? li.join('<br>') : null;
    rows.push({cat:'Additional Options',sel:lightingSel,price:lp});
    return {rows:rows,total:total};
  }
  function updateSummary() {
    var data=getSummaryData(); var html='';
    data.rows.forEach(function(r){if(r.cat==='Base Model') return; var empty=!r.sel;
      html+='<tr'+(empty?' class="empty"':'')+'><td>'+r.cat+'</td><td>'+(r.sel||'Not selected')+'</td>';
      var priceCell;
      if(r.price>0) priceCell='+$'+r.price.toLocaleString();
      else if(empty) priceCell='-';
      else if(r.customSeats) priceCell='<span style="color:#e67e22;font-weight:600;">Call for pricing</span>';
      else if(r.cat==='Base Model') priceCell='-';
      else priceCell='Included';
      html+='<td>'+priceCell+'</td></tr>';});
    html+='<tr class="total"><td colspan="2">Total Add-on Cost</td><td>$'+data.total.toLocaleString()+'</td></tr>';
    root.querySelector('#heSummaryBody').innerHTML=html;
    updateSelectionSummaries();
  }

  // ===== SHOPIFY CART API =====
  function addToCart(variantId, properties) {
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:variantId,quantity:1,properties:properties}]})}).then(function(r){return r.json();});
  }
  function sendSlack(properties, total) {
    if(!CONFIG.slackWebhookUrl) return Promise.resolve();
    var text='*New HE5000 Configuration*\n';
    Object.keys(properties).forEach(function(k){text+='>'+k+': '+properties[k]+'\n';});
    text+='\n*Add-on Total: $'+total.toLocaleString()+'*';
    if(properties['Custom Logo']){
      text+='\n\n:frame_with_picture: *Customer requested custom logo branding. Expect an email with the logo file.*';
    }
    return fetch(CONFIG.slackWebhookUrl,{method:'POST',body:JSON.stringify({text:text}),mode:'no-cors'}).catch(function(){});
  }

  // ===== SUBMIT =====
  window.heSubmitConfig = function() {
    // Run the same validateStep used by Continue buttons for every step
    var missing = [];
    stepOrder.forEach(function(sid) {
      var err = validateStep(sid);
      if (err) missing.push((stepLabels[sid] || sid) + ': ' + err);
    });
    if (missing.length) {
      alert('Please complete the following:\n\n' + missing.join('\n'));
      // Scroll to first incomplete step
      for (var i = 0; i < stepOrder.length; i++) {
        if (validateStep(stepOrder[i])) {
          var sec = root.querySelector('#' + stepOrder[i]);
          if (sec) { sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
          break;
        }
      }
      return;
    }

    var data = getSummaryData();

    // Send Slack notification
    var props={};
    data.rows.forEach(function(r){if(r.sel){var clean=String(r.sel).replace(/<br\s*\/?>/gi,', '); props[r.cat]=clean+(r.price>0?' (+$'+r.price.toLocaleString()+')':'');}});
    props['Configuration Add-on Total']='$'+data.total.toLocaleString();
    sendSlack(props, data.total);

    // Redirect back to product page with config data
    var returnUrl = new URLSearchParams(window.location.search).get('return');
    var urlBaseModel = new URLSearchParams(window.location.search).get('baseModel');
    var selectedBase = root.querySelector('input[name="baseModel"]:checked');
    var selectedBaseValue = selectedBase ? selectedBase.value : '';
    // If customer changed the base model from the one they came in with, redirect to the correct product
    var modelUrls = window.HE5000_MODEL_URLS || {};
    if (selectedBaseValue && urlBaseModel && urlBaseModel !== selectedBaseValue && modelUrls[selectedBaseValue]) {
      returnUrl = modelUrls[selectedBaseValue];
    } else if (!returnUrl && selectedBaseValue && modelUrls[selectedBaseValue]) {
      returnUrl = modelUrls[selectedBaseValue];
    }
    if (returnUrl) {
      var configParam = encodeURIComponent(JSON.stringify(data));
      var separator = returnUrl.indexOf('?') > -1 ? '&' : '?';
      window.location.href = returnUrl + separator + 'he_config=' + configParam;
    } else {
      // Fallback: add to cart directly if no return URL
      var variantId=new URLSearchParams(window.location.search).get('variant')||root.getAttribute('data-variant-id');
      if(!variantId){alert('Configuration saved! Return to the product page to add to cart.');return;}
      var btn=root.querySelector('.he-submit-btn'); btn.disabled=true; btn.textContent='Adding to cart...';
      addToCart(parseInt(variantId),props).then(function(){window.location.href=CONFIG.redirectAfterAdd;})
      .catch(function(){alert('Error adding to cart.');btn.disabled=false;btn.textContent='Add Configuration to Cart';});
    }
  };

  // ===== EXPORT / IMPORT =====
  window.heExportConfig = function() {
    var data={}; for(var i=0;i<localStorage.length;i++){var key=localStorage.key(i);
      if(key.startsWith('he_img_')||key.startsWith('he_text_')||key.startsWith('he_price_')||key.startsWith('he_variants_')||key.startsWith('he_opts_'))
        data[key]=localStorage.getItem(key);}
    var json = JSON.stringify(data, null, 2);
    // Try clipboard first (works in iframes)
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(json).then(function() {
        alert('Configuration copied to clipboard!\n\nPaste it into a text file and save as .json\n\nOr paste it directly when prompted by Import Config.');
      }).catch(function() { fallbackExport(json); });
    } else { fallbackExport(json); }
  };
  function fallbackExport(json) {
    // Show in a prompt so user can copy manually
    var w = window.open('', '_blank', 'width=800,height=600');
    if (w) {
      w.document.write('<pre style="white-space:pre-wrap;word-wrap:break-word;font-size:12px;">' + json.replace(/</g,'&lt;') + '</pre>');
      w.document.title = 'HE5000 Config - Copy this text';
    } else {
      prompt('Copy this config JSON:', json);
    }
  }
  window.heImportConfig = function(e) {
    if (e && e.target && e.target.files && e.target.files[0]) {
      var file=e.target.files[0]; var reader=new FileReader();
      reader.onload=function(ev){loadConfigJson(ev.target.result);};
      reader.readAsText(file); e.target.value='';
    } else {
      // Prompt for pasted JSON
      var json = prompt('Paste your exported config JSON here:');
      if (json) loadConfigJson(json);
    }
  };
  function loadConfigJson(json) {
    try{var data=JSON.parse(json); var c=0;
      Object.keys(data).forEach(function(key){localStorage.setItem(key,data[key]);c++;});
      alert('Imported '+c+' items. Reloading...'); location.reload();}
    catch(err){alert('Error: '+err.message);}
  }

  // ===== PRELOADED CONFIG (exported from admin) =====
  var preloadedConfig = {
    "he_img_extStd_he5000fort-1775681397488": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Fort_Yellow.png?v=1775681162",
    "he_img_airm-beige": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/Beige_1.png?v=1775680413",
    "he_img_airm-lightgrey": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/Light_Gray.png?v=1775680414",
    "he_img_airme-lightgrey": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/Light_Gray.png?v=1775680414",
    "he_img_airme-beige": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/Beige_1.png?v=1775680413",
    "he_img_airme-black": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/black_560d522c-b157-4bc5-a822-60701f70b769.png?v=1775680413",
    "he_img_airme-chestnut": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/chestnutbrown.jpg?v=1775680414",
    "he_img_airme-ivoryblue": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/ivoryblue.png?v=1775680414",
    "he_img_airme-blackwhite": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/creamivory.jpg?v=1775680414",
    "he_img_airme-greyblack": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/grayblack.jpg?v=1775680414",
    "he_img_prem-blackwhite-tray": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/Cream_Ivory.png?v=1775680414",
    "he_img_prem-ivory-tray": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/Ivory_Blue.png?v=1775680414",
    "he_img_prem-blackwhite-notray": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/creamivory-no-tray.png?v=1776360137",
    "he_img_prem-ivory-notray": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/ivoryblue-no-tray.png?v=1776360057",
    "he_img_exts-hm-mb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Matte_Black.jpg?v=1775680000",
    "he_img_extp-he-gg": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_greygreen.jpg?v=1776799654",
    "he_img_exts-hm-gb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Glossy_Black.jpg?v=1775679999",
    "he_img_light-bibs": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/bibhe5000.png?v=1786478901",
    "he_img_light-ambient": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/Fort10.webp?v=1774463406",
    "he_img_airm-black": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/black_560d522c-b157-4bc5-a822-60701f70b769.png?v=1775680413",
    "he_img_extp-he-bg": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Dark_Purple.jpg?v=1775679999",
    "he_img_interior-1775665451377": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/warmbeige_1.png?v=1775679011",
    "he_img_extp-hm-gg": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_greygreen.jpg?v=1776799654",
    "he_img_exts-he-gb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Glossy_Black.jpg?v=1775679999",
    "he_img_exts-hf-rd": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Fort_Red.png?v=1776375587",
    "he_img_extp-hf-gg": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/graygreen.jpg?v=1776375587",
    "he_img_extp-hf-dr": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/darkpurple.jpg?v=1776375791",
    "he_img_extp-hf-gr": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Fort_Gray.png?v=1775681209",
    "he_img_extp-hf-custom": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Fort_CC.jpg?v=1776870751",
    "he_img_extp-hp-custom": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_customcc.jpg?v=1776799820",
    "he_img_extp-hm-custom": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_customcc.jpg?v=1776799820",
    "he_img_extp-he-custom": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_customcc.jpg?v=1776799820",
    "he_img_extp-he-bg": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_beige.jpg?v=1776869885",
    "he_img_extp-hm-bg": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_beige.jpg?v=1776869885",
    "he_img_extp-hp-bg": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000PLUS_Beige.jpg?v=1775680741",
    "he_img_light-star": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/star.png?v=1775680582",
    "he_img_light-tv": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/5e4a97f1-4b18-4ee9-b93d-657b3f3fbecd.jpg?v=1776442332",
    "he_img_light-book": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/1731780448.jpg?v=1776787865",
    "he_img_light-warranty": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/2year_warranty.png?v=1776456604",
    "he_img_light-asme": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/ASME_Certification.png?v=1776787620",
    "he_img_light-whiteglove": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/ArcherWGS.jpg?v=1776787941",
    "he_img_airm-ivoryblue": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/ivoryblue.png?v=1775680414",
    "he_img_exts-hm-wh": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_White.jpg?v=1775680003",
    "he_img_airm-silverblack": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/grayblack.jpg?v=1775680414",
    "he_img_airm-chestnut": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/chestnutbrown.jpg?v=1775680414",
    "he_img_exts-he-lb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/lightblue.jpg?v=1775680205",
    "he_img_airm-blackwhite": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/creamivory.jpg?v=1775680414",
    "he_img_exts-hp-wh": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000Plus_White.jpg?v=1775680741",
    "he_variants_wood": "[{\"id\":\"wood-1\",\"label\":\"Oakwood #1\"},{\"id\":\"wood-2\",\"label\":\"Oakwood #2\"},{\"id\":\"wood-3\",\"label\":\"Mahogany #3\"},{\"id\":\"wood-4\",\"label\":\"Mahogany #4\"},{\"id\":\"wood-5\",\"label\":\"Wenge #5\"},{\"id\":\"wood-6\",\"label\":\"Walnut #6\"},{\"id\":\"wood-7\",\"label\":\"Marble Pattern\"},{\"id\":\"wood-8\",\"label\":\"Black\"}]",
    "he_img_wood-1": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/oakwood_1.png?v=1776121166",
    "he_img_wood-2": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/oakwood_2.png?v=1776121166",
    "he_img_wood-3": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/mahogany_3.png?v=1776121168",
    "he_img_wood-4": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/mahogany_4.png?v=1776121166",
    "he_img_wood-5": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/Wenge_5.png?v=1776121166",
    "he_img_wood-6": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/Walnut_6.png?v=1776121166",
    "he_img_wood-7": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/marble_pattern.png?v=1783976309",
    "he_img_wood-8": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/Black_wood.png?v=1783976321",
    "he_img_extStd_he5000fort-1775681410656": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Fort_Orange.png?v=1775681162",
    "he_img_light-reading": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/warmwhite_1.png?v=1775680581",
    "he_img_extp-hp-dr": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000PLUS_Dark_Purple.jpg?v=1775680741",
    "he_img_exts-hp-lb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000Plus_Glossy_Black.jpg?v=1775680742",
    "he_img_exts-hf-wh": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Fort_White.png?v=1775681162",
    "he_img_int-stonegrey": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/stone-grey_2.jpg?width=1200&v=1787921589",
    "he_img_exts-hf-gb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Fort_Glossy_Black.png?v=1775681162",
    "he_img_int-black": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/black_7da35db8-c4b6-4b56-b4e8-5449e2d64ae1.jpg?width=1200&v=1787921590",
    "he_img_int-warmbeige": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/warm-beige.webp?width=1200&v=1787921588",
    "he_img_exts-he-rd": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Red.jfif.webp?v=1775860221",
    "he_img_exts-hm-nb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Blue.jpg?v=1775679999",
    "he_img_regs-blackbrown": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/blackbrown.jpg?v=1775680331",
    "he_img_regs-black": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/black_1.png?v=1775680329",
    "he_text_header-desc": "Select your preferred options for the HE5000 series.",
    "he_img_exts-hp-nb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000PLUS_Navy_Blue.jpg?v=1775680741",
    "he_img_carpet-beige": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/Beigecarpet.png?v=1775678970",
    "he_img_exts-he-nb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Blue.jpg?v=1775679999",
    "he_img_exts-he-wh": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_White.jpg?v=1775680003",
    "he_img_extp-hp-bg": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000PLUS_Beige.jpg?v=1775680741",
    "he_img_exts-hm-lb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/lightblue.jpg?v=1775680205",
    "he_img_redlight-panel": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/redlight_b7c4f8bb-a82f-4aa6-96a7-05df20c0fe00.png?v=1775680582",
    "he_img_regs-beige": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/beigeseat.png?v=1775680330",
    "he_img_int-slategrey": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/slate-grey.webp?width=1200&v=1787921588",
    "he_img_regs-brown": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/brown.png?v=1775680330",
    "he_img_carpet-light": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/lightcarpet.png?v=1775678970",
    "he_img_exts-hp-mb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000PLUS_Matte_Black.jpg?v=1776375187",
    "he_img_extp-hm-dr": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Dark_Purple.jpg?v=1775679999",
    "he_img_exts-he-mb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Matte_Black.jpg?v=1775680000",
    "he_img_exts-hp-rd": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000PLUS_Red.jpg?v=1775680741",
    "he_img_exts-hf-nb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Fort_Blue.png?v=1775681162",
    "he_img_extp-hf-bg": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000Fort_Beige.png?v=1775681162",
    "he_img_exts-hf-mb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000Fort_Matte_Black.png?v=1775681163",
    "he_img_exts-hm-rd": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Red.jfif.webp?v=1775860221",
    "he_img_carpet-dark": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/darkcarpet.png?v=1775678959",
    "he_img_exts-hp-gb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000Plus_Glossy_Black.jpg?v=1776375187",
    "he_img_extp-hp-gg": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000PLUS_Matte_Gray-Green.jpg?v=1775680741",
    "he_variants_interior": "[{\"id\":\"int-black\",\"label\":\"Black\"},{\"id\":\"int-warmbeige\",\"label\":\"Warm Beige\"},{\"id\":\"int-stonegrey\",\"label\":\"Stone Grey\"},{\"id\":\"int-slategrey\",\"label\":\"Slate Grey\"}]",
    // ===== NEW EXTERIOR COLOR IMAGES (9 Std + 6 Prem per model) =====
    // HE5000 Standard
    "he_img_exts-he-gw": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_glossyw.jpg?v=1776799358",
    "he_img_exts-he-gr": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_gray.jpg?v=1776799354",
    "he_img_exts-he-or": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Orange.jpg?v=1776799354",
    "he_img_exts-he-yl": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_yellow.jpg?v=1776799354",
    "he_img_exts-he-custom": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_customcc.jpg?v=1776799820",
    // HE5000 Premium
    "he_img_extp-he-dp": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Dark_Purple.jfif.webp?v=1775860221",
    "he_img_extp-he-nb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Blue.jfif.webp?v=1775860221",
    "he_img_extp-he-lb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/lightblue.jpg?v=1775680205",
    // HE5000 Mini Standard (same images as HE5000)
    "he_img_exts-hm-gw": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_glossyw.jpg?v=1776799358",
    "he_img_exts-hm-gr": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_gray.jpg?v=1776799354",
    "he_img_exts-hm-or": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Orange.jpg?v=1776799354",
    "he_img_exts-hm-yl": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_yellow.jpg?v=1776799354",
    "he_img_exts-hm-custom": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_customcc.jpg?v=1776799820",
    // HE5000 Mini Premium
    "he_img_extp-hm-dp": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Dark_Purple.jfif.webp?v=1775860221",
    "he_img_extp-hm-nb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Blue.jfif.webp?v=1775860221",
    "he_img_extp-hm-lb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/lightblue.jpg?v=1775680205",
    // HE5000 Plus Standard
    "he_img_exts-hp-gw": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000plus_glossy_white.jpg?v=1776793599",
    "he_img_exts-hp-gr": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_plus_gray.jpg?v=1776793599",
    "he_img_exts-hp-or": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_plus_orange.jpg?v=1776793600",
    "he_img_exts-hp-yl": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_plus_yellow.jpg?v=1776793599",
    "he_img_exts-hp-custom": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/customcc.jpg?v=1776793860",
    // HE5000 Plus Premium
    "he_img_extp-hp-dp": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000PLUS_Dark_Purple.jpg?v=1775680741",
    "he_img_extp-hp-nb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000PLUS_Navy_Blue.jpg?v=1776375187",
    "he_img_extp-hp-lb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000PLUS_Light_Blue.jpg?v=1776375187",
    // HE5000 Fort Standard
    "he_img_exts-hf-gw": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_fort_Glossy_White.jpg?v=1776845573",
    "he_img_exts-hf-gr": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Fort_Gray.png?v=1776375587",
    "he_img_exts-hf-or": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Fort_Orange.png?v=1775681162",
    "he_img_exts-hf-yl": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Fort_Yellow.png?v=1775681162",
    "he_img_exts-hf-custom-std": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Fort_CC.jpg?v=1776870751",
    // HE5000 Fort Premium
    "he_img_extp-hf-dp": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/darkpurple.jpg?v=1776375791",
    "he_img_extp-hf-nb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_Fort_Blue.png?v=1775681162",
    "he_img_extp-hf-lb": "https://cdn.shopify.com/s/files/1/0570/5882/0177/files/HE5000_fort_Light_blue.jpg?v=1776845574"
  };

  // Load preloaded config into localStorage (only if not already set - localStorage overrides take priority)
  function loadPreloadedConfig() {
    // Cleanup stale entries from previous versions
    try {
      localStorage.removeItem('he_img_light-red');
      // Reset lighting variants to remove Red Light Panel entry
      var lightingVariants = localStorage.getItem('he_variants_lighting');
      if (lightingVariants && lightingVariants.indexOf('Red Light Panel') > -1) {
        localStorage.removeItem('he_variants_lighting');
      }
      // Force refresh ALL exterior variants to new uniform color set (8 std + 5 prem per model)
      ['extStd_he5000','extStd_he5000plus','extStd_he5000mini','extStd_he5000fort',
       'extPrem_he5000','extPrem_he5000plus','extPrem_he5000mini','extPrem_he5000fort'].forEach(function(g) {
        var saved = localStorage.getItem('he_variants_' + g);
        if (saved) {
          // Check for a key marker from the new set
          var isStd = g.indexOf('extStd') === 0;
          var marker = isStd ? 'Glossy White' : 'Navy Blue';
          if (saved.indexOf(marker) === -1) {
            localStorage.removeItem('he_variants_' + g);
          }
        }
      });
      // Force refresh Fort Gray Green image to new URL
      var ggImg = localStorage.getItem('he_img_extp-hf-gg');
      if (ggImg && ggImg.indexOf('v=1776375587') === -1) {
        localStorage.removeItem('he_img_extp-hf-gg');
      }
      // Force refresh airManual variants to update "Silver Grey/Black" → "Grey/Black"
      var savedAirManual = localStorage.getItem('he_variants_airManual');
      if (savedAirManual && savedAirManual.indexOf('Silver Grey/Black') > -1) {
        localStorage.removeItem('he_variants_airManual');
      }
      // Force refresh lighting variants to include TV + Additional Options + BIBS
      var savedLighting = localStorage.getItem('he_variants_lighting');
      if (savedLighting && (savedLighting.indexOf('TV') === -1 || savedLighting.indexOf('Protocol Book') === -1 || savedLighting.indexOf('ASME') === -1 || savedLighting.indexOf('BIBS') === -1)) {
        localStorage.removeItem('he_variants_lighting');
      }
      // Remove old airElecTray/airElecNoTray variants — replaced by combined premium group
      localStorage.removeItem('he_variants_airElecTray');
      localStorage.removeItem('he_variants_airElecNoTray');
      // Force refresh updated image URLs
      var bookImg = localStorage.getItem('he_img_light-book');
      if (bookImg && bookImg.indexOf('1731780448') === -1) localStorage.removeItem('he_img_light-book');
      var asmeImg = localStorage.getItem('he_img_light-asme');
      if (asmeImg && asmeImg.indexOf('v=1776787620') === -1) localStorage.removeItem('he_img_light-asme');
      var wgImg = localStorage.getItem('he_img_light-whiteglove');
      if (wgImg && wgImg.indexOf('v=1776787941') === -1) localStorage.removeItem('he_img_light-whiteglove');
      // Force refresh Custom Color and Beige images across all models
      ['extp-hp-custom','extp-hm-custom','extp-he-custom'].forEach(function(k){
        var v = localStorage.getItem('he_img_'+k);
        if (v && v.indexOf('HE5000_customcc') === -1) localStorage.removeItem('he_img_'+k);
      });
      ['extp-he-bg','extp-hm-bg'].forEach(function(k){
        var v = localStorage.getItem('he_img_'+k);
        if (v && v.indexOf('HE5000_beige') === -1) localStorage.removeItem('he_img_'+k);
      });
      // Force refresh wrong/swapped exterior images
      var fixImgs = {
        'exts-he-gb': 'HE5000_Glossy_Black', 'exts-he-rd': 'HE5000_Red.jfif',
        'exts-hm-gb': 'HE5000_Glossy_Black', 'exts-hm-rd': 'HE5000_Red.jfif',
        'exts-hf-gb': 'HE5000_Fort_Glossy_Black', 'exts-hf-rd': 'v=1776375587',
        'exts-hp-mb': 'v=1776375187', 'exts-hp-gb': 'HE5000Plus_Glossy_Black',
        'extp-he-gg': 'HE5000_greygreen', 'extp-hm-gg': 'HE5000_greygreen',
        'wood-7': 'marble_pattern', 'wood-8': 'Black_wood'
      };
      Object.keys(fixImgs).forEach(function(k){
        var v = localStorage.getItem('he_img_'+k);
        if (v && v.indexOf(fixImgs[k]) === -1) localStorage.removeItem('he_img_'+k);
      });
      // Force refresh wood variants to new 8-option set
      var savedWood = localStorage.getItem('he_variants_wood');
      if (savedWood && savedWood.indexOf('Oakwood') === -1) {
        localStorage.removeItem('he_variants_wood');
        // Also clear old wood images
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (k && k.startsWith('he_img_wood-7')) { localStorage.removeItem(k); i--; }
        }
      }
      // Rename Sapele #7 → Marble Pattern and Wood #8 → Black in cached label list
      if (savedWood && (savedWood.indexOf('Sapele') > -1 || savedWood.indexOf('Wood #8') > -1)) {
        localStorage.removeItem('he_variants_wood');
      }
    } catch(e) {}

    Object.keys(preloadedConfig).forEach(function(key) {
      if (!localStorage.getItem(key)) {
        localStorage.setItem(key, preloadedConfig[key]);
      }
    });
  }

  // ===== CUSTOM LOGO REQUEST =====
  // Simple checkbox - customer will email logo after placing order

  // ===== RESTORE STATIC IMAGES =====
  function restoreStaticImages() {
    root.querySelectorAll('[data-img-key]').forEach(function(wrap) {
      var key = wrap.getAttribute('data-img-key');
      try {
        var saved = localStorage.getItem('he_img_' + key);
        if (saved && !wrap.querySelector('img')) {
          setImage(key, saved);
        }
      } catch(e) {}
    });
  }

  // ===== BASE MODEL CARD SELECTION =====
  window.heSelectBaseModel = function(cardEl, value) {
    if (editMode) return;
    root.querySelectorAll('.he-base-model-card').forEach(function(c) { c.classList.remove('selected'); });
    cardEl.classList.add('selected');
    root.querySelectorAll('input[name="baseModel"]').forEach(function(r) { r.checked = (r.value === value); });
    window.heToggleExteriorByModel();
    if (!editMode) window.heOnSelect('sec-base');
    updateSummary();
  };

  function autoSelectBaseModel() {
    var params = new URLSearchParams(window.location.search);
    var modelFromUrl = params.get('baseModel');
    if (!modelFromUrl) return;
    var cards = root.querySelectorAll('.he-base-model-card');
    for (var i = 0; i < cards.length; i++) {
      var label = cards[i].querySelector('.he-base-model-label');
      if (label && label.textContent.trim() === modelFromUrl) {
        cards[i].classList.add('selected');
        root.querySelectorAll('input[name="baseModel"]').forEach(function(r) { r.checked = (r.value === modelFromUrl); });
        window.heToggleExteriorByModel();
        updateSummary();
        return;
      }
    }
  }

  // ===== INIT =====
  loadPreloadedConfig();
  loadSavedOptions();
  loadSavedTexts();
  loadSavedPrices();
  Object.keys(defaultVariants).forEach(function(g){renderGrid(g);});
  restoreStaticImages();
  initWizard();
  autoSelectBaseModel();
  // Apply default radio selections: show conditional sections for pre-checked radios
  window.heToggleFlooring();
  window.heToggleExterior();
  window.heToggleSeating();
  updateSummary();
})();
